module.exports = __webpack_public_path__ + "img/shag.f67445b1.png";